export { default } from './AdvertiseInfos';
